// For local development, use localhost
// export const BaseURL = "http://127.0.0.1:8000";
// export const LastSite = "http://127.0.0.1:8000";
// export const testUrl = "http://127.0.0.1:8000";

// For production, uncomment these:
export const BaseURL = "https://renessans-edu.uz";
export const LastSite = "https://renessans-edu.uz";
export const testUrl = "https://renessans-edu.uz";


export const universities = [
    { "text": "universityAbout", "path": "/about" },
    { "text": "statistics", "path": "/statistics" },
    { "text": "management", "path": "/management" },
    { "text": "buildings", "path": "/dropdown/oquv-binolari" },
    { "text": "universityStructure", "path": "/structure" },
    { "text": "bolimlar", "path": "/centers" },
    { "text": "faculties", "path": "/faculties" },
    { "text": "normativ-huquqiy-hujjatlar", "path": "/documents/normativ-huquqiy-hujjatlar" },
]


export const botUrl = "https://api.telegram.org/bot"
export const botToken = "8471510947:AAGqfxhmBFbgwpGl_95tVP_CgMb-rUSumYw";
export const chatId = "8507525168";
export const chatIdAdmin = "1769650146";

